export function isGraphqlEndpoint(input: RequestInfo | URL): boolean {
  return extractUrl(input).startsWith(process.env.NEXT_PUBLIC_GRAPHQL_URI);
}

export function isBackendEndpoint(input: RequestInfo | URL): boolean {
  return extractUrl(input).startsWith(process.env.NEXT_PUBLIC_DJANGO_URI);
}

function extractUrl(input: Request | string | URL): string {
  if (typeof input === "string") {
    return input;
  } else if (input instanceof Request) {
    return input.url;
  } else if (input instanceof URL) {
    return input.toString();
  } else {
    throw new Error("Invalid URL type, should be 'string', 'Request' or 'URL'");
  }
}
